let gisPromise;

export function loadGis() {
  if (typeof window !== 'undefined' && window.google?.accounts?.id) {
    return Promise.resolve();
  }
  if (!gisPromise) {
    gisPromise = new Promise((resolve, reject) => {
      const s = document.createElement('script');
      s.src = 'https://accounts.google.com/gsi/client';
      s.async = true;
      s.defer = true;
      s.onload = () => resolve();
      s.onerror = e => reject(new Error('Failed to load Google GIS script'));
      document.head.appendChild(s);
    });
  }
  return gisPromise;
}
